var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessSources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3799 1.44557L22.3714 1.43731C22.2158 1.27677 22.001 1.18696 21.777 1.18954C21.7494 1.18825 21.7215 1.19083 21.6944 1.19806H9.01184C6.73213 1.19857 4.88446 3.0465 4.88342 5.32647V31.7482C4.88446 34.028 6.73213 35.8759 9.01184 35.8767H27.4C29.6797 35.8759 31.5277 34.028 31.5284 31.7482V10.9242C31.5269 10.7056 31.4412 10.4958 31.2889 10.3383L22.3799 1.44557ZM22.6026 4.00531L28.7292 10.1153H25.0798C23.7135 10.1112 22.6065 9.00452 22.6026 7.63845V4.00531ZM27.4083 34.2171H9.01184C7.64551 34.2133 6.53907 33.1063 6.53469 31.74V5.31796C6.53907 3.95188 7.64551 2.84493 9.01184 2.84106H20.9514V7.63845C20.9522 9.91791 22.8001 11.7658 25.0798 11.7669H29.8772V31.74C29.8798 33.1058 28.7741 34.2153 27.4083 34.2171Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1761 17.1254H19.1019C19.5577 17.1254 19.9278 16.7558 19.9278 16.2997C19.9278 15.8437 19.5577 15.4741 19.1019 15.4741H10.1761C9.72005 15.4741 9.35046 15.8437 9.35046 16.2997C9.35046 16.7558 9.72005 17.1254 10.1761 17.1254Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 21.7163H10.1761C9.72005 21.7163 9.35046 22.0859 9.35046 22.5419C9.35046 22.9977 9.72005 23.3675 10.1761 23.3675H26.2441C26.6999 23.3675 27.07 22.9977 27.07 22.5419C27.07 22.0859 26.6999 21.7163 26.2441 21.7163Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 27.9667H10.1761C9.72005 27.9667 9.35046 28.3363 9.35046 28.7923C9.35046 29.2484 9.72005 29.618 10.1761 29.618H26.2441C26.6999 29.618 27.07 29.2484 27.07 28.7923C27.07 28.3363 26.6999 27.9667 26.2441 27.9667Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3799 15.4456L41.3714 15.4373C41.2158 15.2768 41.001 15.187 40.777 15.1895C40.7494 15.1882 40.7215 15.1908 40.6944 15.1981H28.0118C25.7321 15.1986 23.8845 17.0465 23.8834 19.3265V45.7482C23.8845 48.028 25.7321 49.8759 28.0118 49.8767H46.4C48.6797 49.8759 50.5277 48.028 50.5284 45.7482V24.9242C50.5269 24.7056 50.4412 24.4958 50.2889 24.3383L41.3799 15.4456ZM41.6026 18.0053L47.7292 24.1153H44.0798C42.7135 24.1112 41.6065 23.0045 41.6026 21.6385V18.0053ZM46.4083 48.2171H28.0118C26.6455 48.2133 25.5391 47.1063 25.5347 45.74V19.318C25.5391 17.9519 26.6455 16.8449 28.0118 16.8411H39.9514V21.6385C39.9522 23.9179 41.8001 25.7658 44.0798 25.7669H48.8772V45.74C48.8798 47.1058 47.7741 48.2153 46.4083 48.2171Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1761 31.1254H38.1019C38.5577 31.1254 38.9278 30.7558 38.9278 30.2997C38.9278 29.8437 38.5577 29.4741 38.1019 29.4741H29.1761C28.7201 29.4741 28.3505 29.8437 28.3505 30.2997C28.3505 30.7558 28.7201 31.1254 29.1761 31.1254Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2441 35.7163H29.1761C28.7201 35.7163 28.3505 36.0859 28.3505 36.5419C28.3505 36.9977 28.7201 37.3675 29.1761 37.3675H45.2441C45.6999 37.3675 46.07 36.9977 46.07 36.5419C46.07 36.0859 45.6999 35.7163 45.2441 35.7163Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2441 41.9667H29.1761C28.7201 41.9667 28.3505 42.3363 28.3505 42.7923C28.3505 43.2484 28.7201 43.618 29.1761 43.618H45.2441C45.6999 43.618 46.07 43.2484 46.07 42.7923C46.07 42.3363 45.6999 41.9667 45.2441 41.9667Z",
    fill: "url(#paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.1578,
    y1: 35.8767,
    x2: 18.1578,
    y2: 1.18922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.6201,
    y1: 17.1254,
    x2: 14.6201,
    y2: 15.4741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.1782,
    y1: 23.3675,
    x2: 18.1782,
    y2: 21.7163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 18.1782,
    y1: 29.618,
    x2: 18.1782,
    y2: 27.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 37.1578,
    y1: 49.8767,
    x2: 37.1578,
    y2: 15.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 33.6201,
    y1: 31.1254,
    x2: 33.6201,
    y2: 29.4741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 37.1782,
    y1: 37.3675,
    x2: 37.1782,
    y2: 35.7163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 37.1782,
    y1: 43.618,
    x2: 37.1782,
    y2: 41.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessSources);
export default __webpack_public_path__ + "static/media/process--sources.8259c0ee537b5a5050a14ec931076729.svg";
export { ForwardRef as ReactComponent };